import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiClientBase } from './api-client-base.service';
import { AppHeadersService } from '../headers/app-headers.service';
import { EnvService } from '../env/env.service';

@Injectable()
export class ApiClient extends ApiClientBase {
  constructor(http: HttpClient, headers: AppHeadersService, hosts: EnvService) {
    super(http, headers, () => hosts.apiUrl);
  }
}
